export type StringEnum<T extends string> = {
    [id: string]: T
}

export const keysForStringEnum = <T extends string>(enumm: StringEnum<T>): T[] => {
    return Object.keys(enumm).map((key) => enumm[key])
}
